import { render } from "./TaskDelete.vue?vue&type=template&id=7ec2ff6e"
import script from "./TaskDelete.vue?vue&type=script&lang=js"
export * from "./TaskDelete.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.10.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__